var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bl-no-data"},[_c('el-empty',{attrs:{"description":_vm.$t('common.noData') || _vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }